import {Component, EventEmitter, inject, Input, OnChanges, Output} from '@angular/core';
import {BaseModel} from '../../../core/definitions/base-model';
import {FieldParameters} from '../../../core/definitions/field-parameters';
import {MetaField} from '../../../core/definitions/meta-field';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {InlineArrayItemService} from '../../../core/inline-array-item.service';
import {FieldValidationService} from '../../../core/field-validation.service';
import {CopyKeepService} from '../../copy-keep-checkbox/copy-keep.service';
import {CrudService} from "../../../core/crud.service";
import {FieldKeyService} from "../../../core/field-key.service";

@Component({
    selector: 'app-edit-field-inline-array-item-list',
    templateUrl: './edit-field-inline-array-item-list.component.html',
    styleUrls: ['./edit-field-inline-array-item-list.component.scss'],
    standalone: false
})
export class EditFieldInlineArrayItemListComponent implements OnChanges {
  // Injections
  public readonly crud: CrudService = inject(CrudService);
  private readonly copyKeepService: CopyKeepService = inject(CopyKeepService);
  private readonly fieldValidationService: FieldValidationService = inject(FieldValidationService);
  private readonly inlineArrayItemSvc: InlineArrayItemService = inject(InlineArrayItemService);
  private readonly fieldKeyService: FieldKeyService = inject(FieldKeyService);

  @Input() items: BaseModel[];
  @Input() fieldParameters: FieldParameters;
  // Disable not implemented yet
  @Input() disabled: boolean;
  @Output() fieldOutsideTheScreen = new EventEmitter<object>();

  private fieldKey: string;

  ngOnChanges(): void {
    if (this.fieldParameters.field.key.includes('{index3}')) {
      console.log('Error: Inline array items inside nested inline arrays are not supported yet.');
    } else if (this.fieldParameters.field.key.includes('{index2}')) {
      this.fieldParameters.index ??= 0;
      this.fieldKey = this.fieldKeyService.getFieldKeyWhileDrawingInputs(
        this.field, this.fieldParameters.parentIndex, this.fieldParameters.index);
    } else {
      this.fieldKey = this.fieldKeyService.getFieldKeyWhileDrawingInputs(this.field, this.fieldParameters.parentIndex);
    }
  }

  get field(): MetaField {
    return this.fieldParameters.field;
  }

  checkFieldOutsideTheScreen() {
    this.fieldOutsideTheScreen.emit();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.copyKeepService.moveKeepObjects(this.fieldParameters, event.previousIndex, event.currentIndex);
    this.items.forEach((item, index) => {
      item.order_number = index;
    });
    this.fieldParameters.index = event.currentIndex;
    this.inlineArrayItemSvc.changeInlineArrayItemsOrder(this.fieldParameters);
  }

  onDragStart() {
    this.inlineArrayItemSvc.setOpenArrayItemIndex(this.fieldParameters, undefined);
  }

  get isInvalid() {
    return this.fieldValidationService.isFieldInvalid(this.fieldParameters.sectionsContainer, this.fieldKey);
  }

}
